import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { StepProps } from '@/views/bonus-engine-form/hooks/use-steps.hook'

import { CustomStep, CustomTab } from '@/views/components'
import { BonusType } from '@/enums/be-bonus-type.enum'
import NavigationStepComponent from './navigation-step.component'

type Props = {
  handleCreateBonusOffer: () => void
  getContent: (step: StepProps) => {
    settings: JSX.Element
  }
  disableSubmit: boolean
  steps: StepProps[]
  typeBonusOffer: BonusType
}

const SettingsComponent = ({
  handleCreateBonusOffer,
  getContent,
  disableSubmit,
  steps,
  typeBonusOffer,
}: Props) => {
  const { t } = useTranslation()

  const listTabItem = (): CustomTab[] => {
    switch (typeBonusOffer) {
      case BonusType.CASINO_STANDARD:
      case BonusType.SPORTS_STANDARD:
      // case BonusType.FREE_PLAY:
      case BonusType.BETSOFT_CASINO:
        return steps.map((step, index) => {
          return {
            id: index,
            title: t(`${step.label}`),
            label: step.label,
            childrenComponent: getContent(step).settings,
            disabled: step.disable,
            required:
              typeBonusOffer === BonusType.CASINO_STANDARD ||
              typeBonusOffer === BonusType.BETSOFT_CASINO
                ? index <= 4
                : index <= 3,
          }
        })

      case BonusType.FREE_SPINS:
        return steps.map((step, index) => {
          return {
            id: index,
            title: t(`${step.label}`),
            label: step.label,
            childrenComponent: getContent(step).settings,
            disabled: step.disable,
            // general, trigger, free spins and restrictions are all mandatory
            required: index <= 3,
          }
        })

      default:
        return []
    }
  }

  const tabsItems = listTabItem()
  return (
    <Box
      sx={{
        height: '100%',
        display: 'block',
        width: '100%',
      }}
    >
      <CustomStep tabsArray={tabsItems}>
        <NavigationStepComponent
          disableSubmit={disableSubmit}
          handleCreateBonusOffer={handleCreateBonusOffer}
        />
      </CustomStep>
    </Box>
  )
}

export default SettingsComponent
